const initialState = {
  center: { lat: 28.6139, lng: 77.209 }, // Default coordinates for Delhi, India
  zoom: 20, // Default zoom level
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CENTER':
      return {
        ...state,
        center: action.payload,
      };
    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.payload,
      };
    default:
      return state;
  }
};

export default mapReducer;
